import { useQuery, queryOptions } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";
import type { Ref } from "vue";

interface GetPartByIdQueryOptions {
  id: Ref<string>;
}

export const getPartByIdQuery = (options: GetPartByIdQueryOptions) => {
  return queryOptions({
    queryKey: ["parts", "get-by-id", options.id],
    queryFn: async () => {
      return handleClientMethod(
        getClient().GET("/parts/{id}", {
          params: {
            path: {
              id: options.id.value,
            },
          },
        }),
      );
    },
  });
};

export const useGetPartById = (options: GetPartByIdQueryOptions) => {
  return useQuery(getPartByIdQuery(options));
};
